import { render, staticRenderFns } from "./CommercialForm.vue?vue&type=template&id=1990fe1d&scoped=true&lang=html&"
import script from "./CommercialForm.vue?vue&type=script&lang=js&"
export * from "./CommercialForm.vue?vue&type=script&lang=js&"
import style0 from "./CommercialForm.vue?vue&type=style&index=0&id=1990fe1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990fe1d",
  null
  
)

export default component.exports